export const mockData = {
  original: [
    {
      id: "GCAT | Genomes for Life (EGAD00001007774)",
      results: [
        {
          frequencyInPopulations: [
            {
              frequencies: [
                {
                  population: "Total",
                  alleleCount: 2,
                  alleleNumber: 1182,
                  alleleFrequency: 0.99,
                  genotypeHomozygous: 0.1,
                  genotypeHeterozygous: 2,
                },
                {
                  population: "XX",
                  alleleCount: 2,
                  alleleNumber: 794,
                  alleleFrequency: 0.1,
                  genotypeHomozygous: 0.24,
                  genotypeHeterozygous: 2,
                  genotypeHemizygous: 0.1,
                },
                {
                  population: "XY",
                  alleleCount: 3,
                  alleleNumber: 388,
                  alleleFrequency: 0.88,
                  genotypeHomozygous: 1,
                },
                {
                  population: "European",
                  alleleCount: 2,
                  alleleNumber: 1182,
                  alleleFrequency: 0.89,
                  genotypeHomozygous: 1,
                },
                {
                  population: "European XX",
                  alleleCount: 2,
                  alleleNumber: 794,
                  alleleFrequency: 0.157,
                },
                {
                  population: "European XY",
                  alleleCount: 0,
                  alleleNumber: 388,
                  alleleFrequency: 0.85,
                },
              ],
            },
          ],
        },
      ],
      resultsCount: 1,
    },

    {
      id: "gnomADv2.1.1",
      results: [
        {
          frequencyInPopulations: [
            {
              frequencies: [
                {
                  population: "Total",
                  alleleCount: 17,
                  alleleNumber: 168560,
                  alleleFrequency: 0.8,
                },

                {
                  population: "Admixed American",
                  alleleCount: 1,
                  alleleNumber: 24195,
                  alleleFrequency: 0.8,
                },

                {
                  population: "East Asian",
                  alleleCount: 0,
                  alleleNumber: 12472,
                  alleleFrequency: 1,
                },

                {
                  population: "East Asian XY",
                  alleleCount: 0,
                  alleleNumber: 3308,
                  alleleFrequency: 0.9,
                },

                { population: "Japanese", alleleCount: 0, alleleNumber: 121 },
                { population: "Korean", alleleCount: 0, alleleNumber: 2727 },
                {
                  population: "Other East Asian",
                  alleleCount: 0,
                  alleleNumber: 9624,
                  alleleFrequency: 0.1,
                },

                {
                  population: "European (non-Finnish)",
                  alleleCount: 15,
                  alleleNumber: 76704,
                  alleleFrequency: 0.9,
                },
                {
                  population: "European (non-Finnish) XX",
                  alleleCount: 7,
                  alleleNumber: 49302,
                  alleleFrequency: 0.7,
                },
                {
                  population: "European (non-Finnish) XY",
                  alleleCount: 8,
                  alleleNumber: 27402,
                  alleleFrequency: 0.5,
                },

                {
                  population: "North-western European",
                  alleleCount: 10,
                  alleleNumber: 27241,
                  alleleFrequency: 0.5,
                },
                {
                  population: "Southern European",
                  alleleCount: 2,
                  alleleNumber: 6904,
                  alleleFrequency: 0.5,
                },
                {
                  population: "XX",
                  alleleCount: 2,
                  alleleNumber: 6904,
                  alleleFrequency: 0.5,
                },
                {
                  population: "XY",
                  alleleCount: 2,
                  alleleNumber: 6904,
                  alleleFrequency: 0.3,
                },
              ],
            },
          ],
        },
      ],
      resultsCount: 1,
    },
  ],

  lifted: [],
};
